// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reply-btn[data-v-650f4d2d] {
  cursor: pointer;
}
.reply-time[data-v-650f4d2d] {
  position: relative;
  top: 1px;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/apps/conversations/components/message/MessageFooter.vue","webpack://./MessageFooter.vue"],"names":[],"mappings":"AAEA;EACE,eAAA;ACDF;ADIA;EACE,kBAAA;EACA,QAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.reply-btn {\n  cursor: pointer;\n}\n\n.reply-time {\n  position: relative;\n  top: 1px;\n}\n",".reply-btn {\n  cursor: pointer;\n}\n\n.reply-time {\n  position: relative;\n  top: 1px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
